import { useRouter, type ErrorComponentProps } from '@tanstack/react-router';
import { EstadoDeErro } from '@/components/comuns/Estados';
import { eErroSemAcessoATela } from '@/features/permissoes/guardas';
import { SemAcesso } from './SemAcesso';

/**
 * Erro de qualquer rota (guarda ou carregamento). Tela sem permissão vira "Você não tem acesso a
 * esta tela." (CA-02); o resto, o estado de erro com "Tentar de novo".
 */
export function ErroDaRota({ error, reset }: ErrorComponentProps) {
  const router = useRouter();
  if (eErroSemAcessoATela(error)) return <SemAcesso />;
  return (
    <EstadoDeErro
      erro={error}
      aoTentarDeNovo={() => {
        reset();
        void router.invalidate();
      }}
    />
  );
}
